export type PresentationSurface = "standalone" | "app";

/**
 * Resolve the UI owner before the first render.
 *
 * `surface=app` is an explicit contract with pi-feeder-app: Flutter owns
 * navigation, device health, and settings, while this page owns the map and
 * its Aircraft/Airport content. Unknown values deliberately fall back to the
 * standalone website.
 */
export function presentationSurfaceFromSearch(search: string): PresentationSurface {
  return new URLSearchParams(search).get("surface") === "app" ? "app" : "standalone";
}
